<template>
  <div>
    <div class="d-sm-flex bg-light justify-content-sm-between mb-3 p-2 border border-top-0 noPrint">
    <p class="small mb-0">
      <b class="d-block">Destinatii: </b> {{ destinations }}
    </p>
    <p class="small mb-0">
      <b class="d-block">Zone: </b> {{ areas }}
    </p>
    <p class="small mb-0">
      <b class="d-block">Categorii: </b> {{ categories }}
    </p>
    <p class="small mb-0">
      <b class="d-block">Plecare de la: </b> {{ departure_points }}
    </p>
  </div>
  <div class="print-only w-100">
    <table class="table w-100">
      <tr>
        <td> <span><b class="d-block">Destinatii: </b> {{ destinations }}</span></td>
        <td><span><b class="d-block">Zone: </b> {{ areas }}</span></td>
        <td><span><b class="d-block">Categorii: </b> {{ categories }}</span></td>
        <td><span><b class="d-block">Plecare de la: </b> {{ departure_points }}</span></td>
      </tr>
    </table>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    }
  },
  computed: {
    destinations () {
      return this.result.destinations.map(el => el.name).join(', ')
    },
    areas () {
      return this.result.areas.map(el => el.name).join(', ')
    },
    categories () {
      return this.result.categories.map(el => el.name).join(', ')
    },
    departure_points () {
      return this.result.departure_points.map(el => el.name).join(', ')
    }
  }
}
</script>
